export const ErrNodeAuxNonExistAgainstHIndex =
  'non-existence proof being checked against hIndex equal to nodeAux';
